<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{ 'businessIntelligence.relatorioSpnv.dealers' }}
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)"
                >
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <hr>

            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.relatorioSpnv.dataInicial' }}
                </div>
                <p-calendar
                  [(ngModel)]="dataInicial"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  [maxDate]="maxDate"
                  (onClearClick)="limpaDataInicial()"
                  placeholder="{{ 'businessIntelligence.relatorioSpnv.dataInicialPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <div class="col col-4">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.relatorioSpnv.dataFinal' }}
                </div>
                <p-calendar
                  [(ngModel)]="dataFinal"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  [maxDate]="maxDate"
                  (onClearClick)="limpaDataFinal()"
                  placeholder="{{ 'businessIntelligence.relatorioSpnv.dataFinalPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <div class="col col-4">
                <button
                  translate
                  type="button"
                  class="btn btn-primary mt-3 mr-2"
                  (click)="filtroAPI()"
                >
                  {{ 'businessIntelligence.relatorioSpnv.filtrar' }}
                  <i class="fas fa-search"></i>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()"
                  [disabled]="!dealersDados?.length"
                >
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>

            <hr>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div
      translate
      *ngIf="dealersDados?.length <= 0 && !cargaTela"
      class="sem-registros text-muted mt-2"
    >
      {{ 'businessIntelligence.relatorioSpnv.nenhumRegistroExibir' }}
    </div>

    <p-table
      #dt
      *ngIf="dealersDados?.length > 0"
      [value]="dealersDados"
      dataKey="idDealer"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [columns]="cols"
      [loading]="loading"
      [autoLayout]="true"
      [globalFilterFields]="['codDealer','dealer','vendasAcessorios','nf0km','retailVista','spnvBaseNf','spnvBaseVista']"
      id="excel-table"
    >
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{ 'businessIntelligence.relatorioSpnv.filtroGeral' | translate }}"
            />
          </span>

          <p-multiSelect
            *ngIf="translate.currentLang == 'br'"
            [options]="colsSemDetalhe"
            [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{ 'businessIntelligence.relatorioSpnv.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.relatorioSpnv.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>

          <p-multiSelect
            *ngIf="translate.currentLang == 'gb'"
            [options]="colsSemDetalhe"
            [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{ 'businessIntelligence.relatorioSpnv.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.relatorioSpnv.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            class="text-center"
            style="background-color:black;color:white;width:40px;"
          ></th>
          <ng-container *ngFor="let col of selectedColumns">
            <th
              class="text-center"
              [translate]="getTranslate(col.header)"
              [pSortableColumn]="col.field"
              style="background-color:black;color:white;"
            >
              {{ translate.currentLang == 'br' ? col.headerBr : col.headerGb }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="sort" />
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr [class.row-selected]="dealerSelecionado?.idDealer === row.idDealer">
          <td class="text-center" style="padding: 2px;">
            <button
              class="btn-ver"
              pTooltip="{{ 'businessIntelligence.relatorioSpnv.verDetalhe' | translate }}"
              (click)="detalharDealer(row)"
              style="cursor: pointer;"
            >
              <img src="assets/img/detail.png" alt="detalhe" />
            </button>
          </td>
          <ng-container *ngFor="let col of selectedColumns">
            <td class="text-center">
              <ng-container [ngSwitch]="col.type">
                <span *ngSwitchCase="'currency'">{{ row[col.field] | number:'1.2-2':'pt-BR' }}</span>
                <span *ngSwitchDefault>{{ row[col.field] }}</span>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr class="footer-total">
          <td class="text-center" style="width: 40px;"></td>
          <ng-container *ngFor="let col of selectedColumns">
            <td class="text-center font-weight-bold">
              <ng-container [ngSwitch]="col.field">
                <span *ngSwitchCase="'codDealer'">
                  {{ isDealerVisible ? '' : ('businessIntelligence.relatorioSpnv.totalNacional' | translate) }}
                </span>
                <span *ngSwitchCase="'dealer'">
                  {{ 'businessIntelligence.relatorioSpnv.totalNacional' | translate }}
                </span>
                <span *ngSwitchCase="'vendasAcessorios'">
                  {{ totalVendasAcessorios | number:'1.2-2':'pt-BR' }}
                </span>
                <span *ngSwitchCase="'nf0km'">
                  {{ totalNf0km }}
                </span>
                <span *ngSwitchCase="'retailVista'">
                  {{ totalRetailVista }}
                </span>
                <span *ngSwitchCase="'spnvBaseNf'">
                  {{ totalSpnvBaseNf | number:'1.2-2':'pt-BR' }}
                </span>
                <span *ngSwitchCase="'spnvBaseVista'">
                  {{ totalSpnvBaseVista | number:'1.2-2':'pt-BR' }}
                </span>
                <span *ngSwitchDefault></span>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>

    <div *ngIf="dealerSelecionado" class="mt-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="mb-0">
          {{ 'businessIntelligence.relatorioSpnv.tituloChassis' | translate }}
          — {{ dealerSelecionado.codDealer }} / {{ dealerSelecionado.dealer }}
        </h5>
        <button
          pButton
          class="p-button-outlined p-button-secondary p-button-sm"
          type="button"
          (click)="exportExcelChassis()"
          [disabled]="!chassisDados?.length"
        >
          <i class="fa fa-download mr-1"></i>Export Excel
        </button>
      </div>

      <div *ngIf="loadingChassis" class="d-flex justify-content-center my-3">
        <p-progressSpinner></p-progressSpinner>
      </div>

      <div
        translate
        *ngIf="!loadingChassis && chassisDados?.length <= 0"
        class="sem-registros text-muted mt-2"
      >
        {{ 'businessIntelligence.relatorioSpnv.nenhumChassisExibir' }}
      </div>

      <p-table
        #dtChassis
        *ngIf="!loadingChassis && chassisDados?.length > 0"
        [value]="chassisDados"
        styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
        [paginator]="chassisDados.length > 10"
        [rows]="10"
        [autoLayout]="true"
        currentPageReportTemplate="{{ 'businessIntelligence.relatorioSpnv.mostrandoRegistros' | translate }}"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,20,30,50,100]"
        [globalFilterFields]="['chassi','chassiBanco','chassiRetail','notaFiscal','dataNotaFiscal','tipoDivergencia']"
      >
        <ng-template pTemplate="caption">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dtChassis.filterGlobal($event.target.value, 'contains')"
              placeholder="{{ 'businessIntelligence.relatorioSpnv.filtroGeral' | translate }}"
            />
          </span>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th
              *ngFor="let col of colsChassis"
              class="text-center"
              [translate]="getTranslate(col.header)"
              [pSortableColumn]="col.field"
              style="background-color:black;color:white;"
            >
              {{ translate.currentLang == 'br' ? col.headerBr : col.headerGb }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td *ngFor="let col of colsChassis" class="text-center">
              <span
                *ngIf="col.field === 'tipoDivergencia'"
                class="badge-divergencia"
                [ngClass]="{
                  'badge-nf': row.chassiBanco && !row.chassiRetail,
                  'badge-retail': !row.chassiBanco && row.chassiRetail,
                  'badge-ambos': row.chassiBanco && row.chassiRetail
                }"
              >
                {{ row.tipoDivergencia }}
              </span>
              <span *ngIf="col.field !== 'tipoDivergencia'">{{ row[col.field] != null && row[col.field] !== '' ? row[col.field] : '—' }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>

<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)"
>
</app-filtro-dealers>
